module.exports = __webpack_public_path__ + "img/example1.5faea00f.jpg";